export const LAYOUT_WIDTH = 30
